import { ROUTE_NAMES as INVESTORS_COMPANIES_ROUTE_NAMES } from './modules/investors/companies/routes'

export const INVESTORS_BO_DETAILS_ROUTE =
  INVESTORS_COMPANIES_ROUTE_NAMES.DETAILS
export const currencies = ['EUR', 'GBP']
export const entityStates = ['PENDING', 'ACTIVE', 'REJECTED', 'DISABLED']
export const NOT_ACCESS_MESSAGE = "You don't have access to this feature"
export const errorMessage = (type, variable) => {
  // type: how the error happened (update, create, delete...)
  // variable: what's the error for (f.e.: grade)
  return `Error ${type} ${variable}. Contact with Tech Team.`
}
export const inputMoneyMask = {
  decimal: '.',
  thousands: '',
  precision: 2,
  masked: false
}

/* Define countries */
const estonia = { text: 'Estonia', value: 'EE' }
const finland = { text: 'Finland', value: 'FI' }
const ireland = { text: 'Ireland', value: 'IE' }
const netherlands = { text: 'Netherlands', value: 'NL' }
const france = { text: 'France', value: 'FR' }
const switzerland = { text: 'Switzerland', value: 'CH' }
const norway = { text: 'Norway', value: 'NO' }
const spain = { text: 'Spain', value: 'ES' }
const sweden = { text: 'Sweden', value: 'SE' }
const unitedKindom = { text: 'United Kingdom', value: 'GB' }
const germany = { text: 'Germany', value: 'DE' }

// List of the possible issuers countries we can have
export const issuerCountries = [
  estonia,
  finland,
  ireland,
  netherlands,
  france,
  norway,
  spain,
  sweden,
  unitedKindom,
  germany
]

// List of the possible debtors countries we can have
export const debtorsCountries = [
  spain,
  finland,
  netherlands,
  unitedKindom,
  estonia,
  sweden,
  norway,
  ireland,
  switzerland,
  germany,
  france
]

// List of the countries we can create a lead
export const leadCountries = [finland, unitedKindom, spain, netherlands]

export const filterCountryCodes = [
  'ES',
  'FI',
  'NL',
  'GB',
  'EE',
  'SE',
  'NO',
  'DE',
  'IE',
  'CH'
]

export const allowedCountries = [
  { text: 'Åland Islands', value: 'AX' },
  { text: 'Austria', value: 'AT' },
  { text: 'Belgium', value: 'BE' },
  { text: 'Bulgaria', value: 'BG' },
  { text: 'Croatia', value: 'HR' },
  { text: 'Cyprus', value: 'CY' },
  { text: 'Czechia', value: 'CZ' },
  { text: 'Denmark', value: 'DK' },
  { text: 'Estonia', value: 'EE' },
  { text: 'Finland', value: 'FI' },
  { text: 'France', value: 'FR' },
  { text: 'Germany', value: 'DE' },
  { text: 'Greece', value: 'EL' },
  { text: 'Hungary', value: 'HU' },
  { text: 'Ireland', value: 'IE' },
  { text: 'Italy', value: 'IT' },
  { text: 'Latvia', value: 'LV' },
  { text: 'Lithuania', value: 'LT' },
  { text: 'Luxembourg', value: 'LU' },
  { text: 'Malta', value: 'MT' },
  { text: 'Netherlands', value: 'NL' },
  { text: 'Norway', value: 'NO' },
  { text: 'Poland', value: 'PL' },
  { text: 'Portugal', value: 'PT' },
  { text: 'Romania', value: 'RO' },
  { text: 'Slovakia', value: 'SK' },
  { text: 'Slovenia', value: 'SI' },
  { text: 'Spain', value: 'ES' },
  { text: 'Sweden', value: 'SE' },
  { text: 'Switzerland', value: 'CH' },
  { text: 'United Kingdom', value: 'GB' }
]

export const nordicCountries = ['FI', 'NO', 'SE', 'EE']

export const euGrades = ['A', 'B', 'C', 'D', 'E']
export const nordicGrades = ['AAA', 'AA', 'A', 'B', 'C', 'AN', 'NA']
export const grades = ['AAA', 'AA', 'A', 'B', 'C', 'D', 'E', 'AN', 'NA']
